export default "__VITE_ASSET__D6rAj5pT__"